import { Text, Pressable, Platform } from 'react-native';
import gs from '../../styles/globalStyles';
import FilledCheckMarkIcon from '../../../assets/Icons/FilledCheckMark';
import EmptyCheckMarkIcon from '../../../assets/Icons/EmptyCheckMark';
import { checkColor } from '@app/utils';


const CheckBox = ({
  size = 12,
  label = null,
  isChecked = false,
  onToggle = () => {},
}) => {
  return (
    <Pressable hitSlop={{top : 20 , left :20 , right : 20 , bottom : 20}} onPress={onToggle} style={[gs.setMarginRight(4)]}>
      {isChecked ? (
        <FilledCheckMarkIcon size={size} color={checkColor('#1434CB')} />
      ) : (
        <EmptyCheckMarkIcon size={size} />
      )}
      {label && <Text>{label}</Text>}
    </Pressable>
  );
};

export default CheckBox;
